// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f9cce639","885":"4f579846"}[chunkId] + ".chunk.js";
};